import React, { useState } from 'react';
import InputField, { InputFieldProps } from 'components/styleguide/input_field/InputField';

interface PasswordFieldProps extends Omit<InputFieldProps, 'type'> {
  minLength?: number;
}

const PasswordField: React.FC<PasswordFieldProps> = ({
  minLength = 8,
  hint,
  value,
  disabled,
  onChange,
  onFocus,
  onBlur,
  ...props
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentValue, setCurrentValue] = useState(value || '');
  const [isFocused, setIsFocused] = useState(false);
  const meetsRequirements = typeof currentValue === 'string' && currentValue.length >= minLength;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue(e.target.value);
    if (onChange) onChange(e);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(false);
    if (onBlur) onBlur(e);
  };

  return (
    <InputField
      {...props}
      value={currentValue}
      type={isVisible ? 'text' : 'password'}
      iconRight={!disabled ? (isVisible ? 'eyeOff' : 'eye') : undefined}
      onIconRightClick={() => setIsVisible(v => !v)}
      hint={isFocused && !meetsRequirements ? hint : undefined}
      disabled={disabled}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
    />
  );
};

export default PasswordField;
